import { createFileRoute } from '@tanstack/react-router';
import { ContactDetailPage } from '../../../features/crm';
import { usePageTitle } from '../../../lib/hooks';

export const Route = createFileRoute('/_auth/crm/$id')({
  component: ContactDetailRoute,
});

function ContactDetailRoute() {
  usePageTitle('Contact Details');
  return <ContactDetailPage />;
}
